module.exports = __webpack_public_path__ + "media/images/categories/r-stats-splash-43e26f2916de1d42d0e71000459bc751.png";